import moment from "moment";

export const DASHBOARD_DEFAULT_DAYS = 14;

export const DASHBOARD_DATE_PRESETS = [
    {key: "14d", label: "14d"},
    {key: "1m", label: "1M"},
    {key: "3m", label: "3M"},
    {key: "1y", label: "1Y"},
];

export const getDashboardDateRangeForPreset = (presetKey) => {
    const endDate = moment().format("YYYY-MM-DD");
    let startDate;

    switch (presetKey) {
        case "1m":
            startDate = moment().subtract(1, "month").format("YYYY-MM-DD");
            break;
        case "3m":
            startDate = moment().subtract(3, "months").format("YYYY-MM-DD");
            break;
        case "1y":
            startDate = moment().subtract(1, "year").format("YYYY-MM-DD");
            break;
        case "14d":
        default:
            startDate = moment().subtract(DASHBOARD_DEFAULT_DAYS - 1, "days").format("YYYY-MM-DD");
            break;
    }

    return {startDate, endDate};
};

export const getDashboardDefaultDateRange = () => getDashboardDateRangeForPreset("14d");

export const getDashboardPresetForRange = (startDate, endDate) => {
    const today = moment().format("YYYY-MM-DD");

    if (endDate !== today) {
        return null;
    }

    return DASHBOARD_DATE_PRESETS.find(({key}) => {
        const presetRange = getDashboardDateRangeForPreset(key);
        return presetRange.startDate === startDate;
    })?.key || null;
};

export const formatDashboardXAxis = (tickItem) => moment(new Date(tickItem)).format("DD.MM");

export const formatCompactNumber = (value) => {
    const num = Number(value);

    if (Number.isNaN(num)) {
        return "0";
    }

    if (num >= 1000000) {
        return `${(num / 1000000).toFixed(1)}m`;
    }

    if (num >= 1000) {
        return `${(num / 1000).toFixed(num >= 10000 ? 0 : 1)}k`;
    }

    return String(Math.round(num));
};

export const formatDashboardYAxisCurrency = (value) => `€${formatCompactNumber(value)}`;

export const DASHBOARD_AXIS_TICK = {fontSize: 10};

export const DASHBOARD_Y_AXIS_WIDTH = 42;
